import React, { useEffect, useState } from 'react'

import { View, StyleSheet, SafeAreaView, Platform, Linking } from 'react-native'

import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';

import { useContent } from '@sart/content'
import { typography, adaptive, colors } from '@sart/styles'
import {
  Text,
  Space
} from '@sart/components'
import { useClient, client } from '@sart/client'
import {
  tabBarTestID,
  isPrepaidService,
  isPostpaidService,
  isFixedLineService,
  isHomePhoneService,
  isMediaService
} from '@sart/utilities'

import {
  GiftSwapIcon,
  Hammer,
  Home,
  Inbox,
  Menu as MenuIcon,
  ShoppingCart,
  TopUp,
} from '@sart/icons'

import { tabsNavigationProps } from './nagivationProps'

import Dashboard from './Dashboard/DashboardStackNavigator'
import TopUpStackNavigator from './TopUp/TopUpStackNavigator'
import BillsStackNavigator from './Bills/BillsStackNavigator'
import GiftSwapStackNavigator from './GiftSwap/GiftSwapStackNavigator'
import ShoppingStackNavigator from './Shopping/ShoppingStackNavigator'
import BuildYourPlanStackNavigator from './BuildYourPlan/BuildYourPlanStackNavigator'
import MoveHomeStackNavigator from './MoveHome/MoveHomeStackNavigator'
import CallHistoryStackNavigator from './CallHistory/CallHistoryStackNavigator'
import SubscriptionsStackNavigator from './Subscriptions/SubscriptionsStackNavigator'
import InboxStackNavigator from './Inbox/InboxStackNavigator'

import MenuStackNavigator from './Menu/MenuStackNavigator'

import CommunityStackNavigator from './Menu/CommunityStackNavigator'

const Tab = createBottomTabNavigator()

function QuickBottomTabsNavigator() {

  const content = useContent()
  const [context, setContext] = useState({ prepaid: true, postpaid: false, fixedline: false, homephone: false, media: false })
  const {
    cache: {
      contextService
    } = {}
  } = useClient()

  useEffect(() => {
    updateContext()
  }, [contextService])

  function updateContext() {
    if (contextService !== undefined) {
      if (isPostpaidService(contextService)) {
        //TODO - this should not have prepaid true and postpaid false, but the data we are getting back is currently incorrect
        setContext({ prepaid: true, postpaid: false, fixedline: false, homephone: false, media: false })
      } else if (isPrepaidService(contextService)) {
        setContext({ prepaid: true, postpaid: false, fixedline: false, homephone: false, media: false })
      } else if (isFixedLineService(contextService)) {
        setContext({ prepaid: false, postpaid: false, fixedline: true, homephone: false, media: false })
      } else if (isHomePhoneService(contextService)) {
        setContext({ prepaid: false, postpaid: false, fixedline: false, homephone: true, media: false })
      } else if (isMediaService(contextService)) {
        setContext({ prepaid: false, postpaid: false, fixedline: false, homephone: false, media: true })
      }
    }
  }

  return (
    <Tab.Navigator
      initialRouteName='Dashboard'
      screenOptions={{
        ...tabsNavigationProps.tabBarOptions,
        headerShown: false,
        swipeEnabled: true,
        animationEnabled: true,
        // unmount tab stacks when blurred so returning tab always starts at its root
        unmountOnBlur: true,
        tabBarStyle: styles.tabBarStyle,
      }}
    >
      {(context.prepaid || context.postpaid || context.fixedline || context.homephone || context.media) &&
        <Tab.Screen
          name="Dashboard"
          component={Dashboard}
          options={{
            // keep Dashboard mounted (don't unmount on blur) because reload is slow
            unmountOnBlur: false,
            tabBarLabel: ({ color }) => (
              <SafeAreaView>
                <Text style={{ color: color, ...styles.textStyle }}>
                  {content.navigation.dashboard}
                </Text>
              </SafeAreaView>
            ),
            tabBarIcon: ({ color }) => (
              <Home color={color} size={28} strokeWidth={2.5} />
            ),
            lazy: false,
            ...tabBarTestID('Dashboard')
          }}
        />
      }
      {(context.prepaid && context.postpaid) &&
        <Tab.Screen
          name="TopUpHome"
          component={TopUpStackNavigator}
          options={{
            tabBarLabel: ({ color }) => (
              <SafeAreaView style={styles.view}>
                <Text style={{ color: color, ...styles.textStyle }}>
                  Top Up
                </Text>
              </SafeAreaView>
            ),
            tabBarIcon: ({ color }) => (
              <Home color={color} />
            ),
            lazy: false,
            ...tabBarTestID('Topup')
          }}
        />
      }
      {((context.postpaid || context.fixedline || context.homephone || context.media) && context.prepaid) &&
        <Tab.Screen
          name="BillsHome"
          component={BillsStackNavigator}
          options={{
            tabBarLabel: ({ color }) => (
              <SafeAreaView>
                <Text style={{ color: color, ...styles.textStyle }}>
                  Bills
                </Text>
              </SafeAreaView>
            ),
            tabBarIcon: ({ color }) => (
              <Bill color={color} />
            ),
            lazy: false,
            ...tabBarTestID('Topup')
          }}
        />
      }
      {(context.prepaid || context.postpaid || context.fixedline || context.homephone || context.media) &&
        <Tab.Screen
          name="Shopping"
          component={ShoppingStackNavigator}
          options={({ navigation }) => ({
            tabBarOnPress: ({ navigation }) => {
              // navigation.popToTop()
              navigation.reset({
                index: 0,
                routes: [
                  {
                    name: 'Shopping',
                  },
                ],
              });
              navigation.popToTop()
              navigation.navigate('Shopping')
            },
            tabBarLabel: ({ color }) => (
              <SafeAreaView>
                <Text style={{ color, ...styles.textStyle }}>
                  Shopping
                </Text>
              </SafeAreaView>
            ),
            tabBarIcon: ({ color }) => (
              <ShoppingCart color={color} size={28} strokeWidth={2.5} />
            ),
            unmountOnBlur: false,
            ...tabBarTestID('Shopping')
          })}
        />
      }
      {(context.prepaid) &&
        <Tab.Screen
          name="GiftSwapHome"
          component={CommunityStackNavigator}
          listeners={{
            tabPress: (e) => {
              e.preventDefault();
              Linking.openURL('https://www.bikermobile.com/community');
            },
          }}
          options={({ navigation }) => ({
            tabBarLabel: ({ color }) => (
              <SafeAreaView>
                <Text style={{ color, ...styles.textStyle }}>
                  {content.navigation.giftSwap}
                </Text>
              </SafeAreaView>
            ),
            tabBarIcon: ({ color }) => (
              <GiftSwapIcon color={color} size={28} strokeWidth={2.5} />
            ),
            ...tabBarTestID('GiftSwap')
          })}
        />
      }
      {(context.postpaid) &&
        <Tab.Screen
          name="BuildYourPlanHome"
          component={BuildYourPlanStackNavigator}
          options={({ navigation }) => ({
            tabBarOnPress: ({ navigation }) => {
              navigation.navigate('BuildYourPlan')
              navigation.popToTop()
            },
            tabBarLabel: ({ color }) => (
              <SafeAreaView>
                <Text style={{ color, ...styles.textStyle }}>
                  {content.navigation.buildPlan}
                </Text>
              </SafeAreaView>
            ),
            tabBarIcon: ({ color }) => (
              <GiftSwapIcon color={color} size={28} strokeWidth={2.5} />
            ),
            ...tabBarTestID('BuildYourPlan')
          })}
        />
      }
      {(context.fixedline) &&
        <Tab.Screen
          name="MoveHome"
          component={MoveHomeStackNavigator}
          options={({ navigation }) => ({
            tabBarOnPress: ({ navigation }) => {
              navigation.navigate('MoveHome')
              navigation.popToTop()
            },
            tabBarLabel: ({ color }) => (
              <SafeAreaView>
                <Text style={{ color, ...styles.textStyle }}>
                  {content.navigation.moving}
                </Text>
              </SafeAreaView>
            ),
            tabBarIcon: ({ color }) => (
              <MoveHome color={color} />
            ),
            ...tabBarTestID('MoveHome')
          })}
        />
      }
      {(context.homephone) &&
        <Tab.Screen
          name="CallHistoryHome"
          component={CallHistoryStackNavigator}
          options={({ navigation }) => ({
            tabBarOnPress: ({ navigation }) => {
              navigation.navigate('CallHistory')
              navigation.popToTop()
            },
            tabBarLabel: ({ color }) => (
              <SafeAreaView>
                <Text style={{ color, ...styles.textStyle }}>
                  {content.navigation.history}
                </Text>
              </SafeAreaView>
            ),
            tabBarIcon: ({ color }) => (
              <CallHistory color={color} />
            ),
            ...tabBarTestID('CallHistory')
          })}
        />
      }
      {(context.media) &&
        <Tab.Screen
          name="SubscriptionsHome"
          component={SubscriptionsStackNavigator}
          options={({ navigation }) => ({
            tabBarOnPress: ({ navigation }) => {
              navigation.navigate('Subscriptions')
              navigation.popToTop()
            },
            tabBarLabel: ({ color }) => (
              <SafeAreaView>
                <Text style={{ color, ...styles.textStyle }}>
                  {content.navigation.manage}
                </Text>
              </SafeAreaView>
            ),
            tabBarIcon: ({ color }) => (
              <Subscriptions color={color} />
            ),
            ...tabBarTestID('Subscriptions')
          })}
        />
      }
      {/* <Tab.Screen
          name="InboxHome"
          component={InboxStackNavigator}
          options={({ navigation }) => ({
            tabBarOnPress: ({ navigation }) => {
              navigation.popToTop()
              navigation.navigate('Inbox')
              navigation.popToTop()
            },
            tabBarLabel: ({ color }) => (
              <SafeAreaView>
                <Text style={{color, ...styles.textStyle}}>
                {content.navigation.inbox}
                </Text>
              </SafeAreaView>
            ),
            tabBarIcon: ({ color }) => (
                <Home color={color} size={28} strokeWidth={2.5} />
            ),
            tabBarBadge: client.cache.newNotifications ? client.cache.newNotificationsTotal : 0,
            tabBarBadgeStyle: client.cache.newNotifications ? {backgroundColor:colors.error, width:12, borderRadius:10, top:Platform.OS === 'ios' ? -10 : 5 } : {display:'none'},
            ...tabBarTestID('Inbox')
          })}
        /> */}
      {(context.prepaid || context.postpaid || context.fixedline || context.homephone || context.media) &&
        <Tab.Screen
          name="MenuHome"
          component={MenuStackNavigator}
          options={{
            lazy: false,
            tabBarLabel: ({ color }) => (
              <SafeAreaView>
                <Text style={{ color, ...styles.textStyle }}>
                  {content.navigation.more}
                </Text>
              </SafeAreaView>
            ),
            tabBarIcon: ({ color }) => (
              <MenuIcon color={color} size={28} strokeWidth={2.5} />
            ),
            ...tabBarTestID('Menu')
          }}
        />
      }
    </Tab.Navigator>
  )
}

export default QuickBottomTabsNavigator

const styles = StyleSheet.create({
  textStyle: {
    // height: 20,
    ...adaptive.tabsFontSize,
    textAlign: 'center',
    ...Platform.select({
      android: {
        // marginLeft: 10,
        // paddingLeft: 0,
        paddingBottom: 10,
        paddingTop: 15
      },
      ios: {
        paddingTop: 15,
      },
      web: {
        paddingBottom: 10,
        paddingTop: 0
      }
    }),
    fontFamily: typography.defaultFontFamily,
    fontWeight: '500'
  },
  tabBarStyle: {
    backgroundColor: colors.darkCharcoal,
    borderTopWidth: 0,
    color: colors.darkCharcoal,
    ...Platform.select({
      web: {
        height:60
      },
      android: {
        paddingTop: 20,
        paddingBottom: 10
      }
    })
  }
})
